import { render } from "./StatisticsView.vue?vue&type=template&id=777f7040&scoped=true"
import script from "./StatisticsView.vue?vue&type=script&lang=js"
export * from "./StatisticsView.vue?vue&type=script&lang=js"

import "./StatisticsView.vue?vue&type=style&index=0&id=777f7040&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-777f7040"]])

export default __exports__